/**
 * pickModuleForPage — pure URL → TicketNext Module resolver.
 *
 * Extracted from ticketnext.bundle.js so the FAB inline copy isn't the only
 * implementation — node:test in tests/frontend/ loads this file directly.
 *
 * Both bindings fire unconditionally. The Node-detect branch in classic UMD
 * wrappers also matches inside esbuild's IIFE shim (it injects a `module`
 * object), which silently prevents `window.tnPickModuleForPage` from being
 * assigned and breaks the FAB's module auto-pick. Always assign both:
 * browser uses the global, Node tests use `require()` and read module.exports.
 *
 * Contract: rules must already be priority-sorted (ascending) by the server.
 * First match wins. Returns the module name (string), or '' on no match.
 */
(function () {
	'use strict';

	function pickModuleForPage(rules, pagePath) {
		if (!rules || !rules.length || !pagePath) return '';
		var path = String(pagePath);
		for (var i = 0; i < rules.length; i++) {
			var r = rules[i];
			if (!r || !r.pattern || !r.module) continue;
			var p = String(r.pattern);
			var hit = false;
			switch (r.match_type) {
				case 'Equals':      hit = (path === p); break;
				case 'Starts With': hit = (path.indexOf(p) === 0); break;
				case 'Regex':
					try { hit = new RegExp(p).test(path); }
					catch (e) { hit = false; }
					break;
				case 'Contains':
				default:            hit = (path.indexOf(p) !== -1); break;
			}
			if (hit) return r.module;
		}
		return '';
	}

	// Browser binding — always assign when window exists, regardless of any
	// module/exports polyfill esbuild may have injected around this IIFE.
	if (typeof window !== 'undefined') {
		window.tnPickModuleForPage = pickModuleForPage;
	}

	// Node binding — used by tests/frontend/test_page_module_matcher.test.js.
	if (typeof module === 'object' && module && module.exports) {
		module.exports = { pickModuleForPage: pickModuleForPage };
	}
})();
